import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {ISendDataArgs} from './types';

export const sendFieldsData = ({url, data}: ISendDataArgs) =>
    performRequest({url, method: ERequestType.POST, data});
